/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Sync_AsnInputs */

const en_inbound_sync_asn = /** @type {(inputs: Inbound_Sync_AsnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ASN to the warehouse (I-08)`)
};

/**
* | output |
* | --- |
* | "ASN to the warehouse (I-08)" |
*
* @param {Inbound_Sync_AsnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_sync_asn = /** @type {((inputs?: Inbound_Sync_AsnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Sync_AsnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_sync_asn(inputs)
});